import React from 'react';
import axios from './../../constants/axios';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router';

class OrderHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         orders: [],
      };
   }

   componentDidMount() {
      axios.get('saleOrders')
         .then((res) => {
            this.setState({
               orders: res.data,
            });
         });
   }

   render() {
      const { orders } = this.state;
      return (
         <div className="OrderHome" >
            <h1>Orders Home</h1>
            <Table>
               <thead>
               <tr>
                  <th>#ord Id</th>
                  <th>Contact Name</th>
                  <th>Amount</th>
                  <th>type {  /** direct sale or home delivery */}</th>
                  <th>delivery time</th>
                  <th >created</th >
                  <th>##</th>
               </tr>
               </thead>
               <tbody>
               {orders.map((sale) => (
                  <tr key={sale.id} >
                     <td>{sale.id}</td>
                     <td>{sale.contact_name}</td>
                     <td >{sale.total_amount}</td >
                     <td >{sale.outlet_id ? "Direct" : "Home Delivery"}</td >
                     <td >{sale.delivery_time}</td >
                     <td >{sale.created_at}</td >
                     <td>
                        <Link to={`/order/orderDetails/${sale.id}`} >Details</Link >
                     </td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

OrderHome.propTypes = {};

export default OrderHome;



/** WEBPACK FOOTER **
 ** ./src/components/OrderManagement/OrderHome.js
 **/